export default {"src":"/_next/static/media/UDR.7ef07b92.svg","height":18,"width":18};